
const Footer = ()=>{
    return <div className="w-screen h-36 bg-slate-600 italic flex flex-col justify-center items-center ">
        <div className="mb-4">
            <h1 className="text-lg font-semibold text-white">2024 Your Company. All rights reserved.</h1>
        </div>
        <div className="flex text-white">
            <div className="mx-3 text-lg">Privacy Policy</div>
            <div className="mx-3 text-lg">Terms of Service</div>
            <div className="mx-3 text-lg">Contact Us</div>
        </div>

    </div>
}
export default Footer;